import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { LinkText } from "../link/LinkText.js";
import "../link/LinkButton.js";
const useStyles = makeStyles()((theme) => ({
  pageHeader: {
    display: "flex",
    justifyContent: "space-between",
    height: theme.custom.pageHeaderHeight,
    minHeight: theme.custom.pageHeaderHeight,
    alignItems: "center",
    padding: theme.spacing(0, 5),
    gap: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.mixins.toolbar.minHeight
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2, 2),
      height: "unset",
      minHeight: "unset"
    },
    [theme.breakpoints.up("md")]: {
      backgroundColor: theme.palette.background.paper,
      paddingLeft: theme.spacing(5)
    }
  },
  pageHeaderSpacing: {
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0
    }
  },
  pageHeaderTitle: {
    display: "flex",
    alignItems: "center"
  },
  pageHeaderTitleStartBreadcrumb: {
    ...theme.typography.h5,
    display: "flex",
    color: theme.palette.text.primary,
    [theme.breakpoints.down("sm")]: {
      ...theme.typography.h6
    }
  },
  pageHeaderTitleStartBreadcrumbWithSubheader: {
    ...theme.typography.h6,
    color: theme.palette.secondary.main
  },
  pageHeaderSubheader: {
    ...theme.typography.h5,
    [theme.breakpoints.down("sm")]: {
      ...theme.typography.h6
    }
  },
  pageHeaderTitleSeparator: {
    alignSelf: "center",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  pageHeaderAction: {
    display: "inline-flex",
    gap: theme.spacing(2)
  },
  pageHeaderSubHeaderLink: {
    color: theme.palette.text.primary
  }
}));
const TitleSeparatorCharacter = "/";
function PageHeader({ header, subHeader, subHeaderLink, removeBottomSpacing, actions }) {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement("div", { className: `${classes.pageHeader} ${!removeBottomSpacing ? classes.pageHeaderSpacing : ""}` }, /* @__PURE__ */ React.createElement("div", { className: classes.pageHeaderTitle }, header ? /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(
        {
          [classes.pageHeaderTitleStartBreadcrumbWithSubheader]: !!subHeader
        },
        classes.pageHeaderTitleStartBreadcrumb
      )
    },
    /* @__PURE__ */ React.createElement(LocalizedText, { label: header }),
    subHeader ? /* @__PURE__ */ React.createElement(Box, { className: classes.pageHeaderTitleSeparator }, TitleSeparatorCharacter) : null
  ) : null, subHeader ? /* @__PURE__ */ React.createElement(Typography, { variant: "h5", color: "textPrimary", "data-testid": "moduleSubHeader" }, subHeaderLink ? /* @__PURE__ */ React.createElement(LinkText, { underline: "none", href: subHeaderLink, title: subHeader, className: classes.pageHeaderSubHeaderLink }) : /* @__PURE__ */ React.createElement(LocalizedText, { label: subHeader })) : null), actions ? /* @__PURE__ */ React.createElement(Box, { className: classes.pageHeaderAction }, actions) : null);
}
export {
  PageHeader
};
//# sourceMappingURL=PageHeader.js.map
